import { createSlice } from '@reduxjs/toolkit';
import { t_medical_institution } from 'types';
import { getFieldMedical } from '../MedicalInstitutionEdit/thunk';

interface InitialState {
  data: t_medical_institution | null;
  fieldsMedical: any[];
}

const initialState: InitialState = {
  data: null,
  fieldsMedical: [],
};

const medicalDetailSlice = createSlice({
  name: 'medicalDetail',
  initialState,
  reducers: {
    updateMedicalDetail: (state, action) => {
      return { ...state, data: action.payload };
    },
    resetMedical: (state, action) => {
      return { ...state, data: null };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFieldMedical.fulfilled, (state, action) => {
      return { ...state, fieldsMedical: Object.entries(action.payload.fields) };
    });
  },
});

export const { updateMedicalDetail, resetMedical } = medicalDetailSlice.actions;

export default medicalDetailSlice.reducer;
